import { Component, OnInit, Input, ComponentRef } from "@angular/core";

import { GenericTable } from "../../../genericTable/models";
import { GatewayView } from "../gateway-view";
import { createDateTimeDisplayCallback } from "../../../util";
import { GatewaysTableBaseComponent } from "../gateways-table-base.component";
import { PendingAcceptComponent } from "./pending-accept/pending-accept.component";
import { SdpIcon } from "app/common/icon/models";

@Component({
	selector: "sdp-gateway-pending",
	templateUrl: "./gateway-pending.component.html"
})
export class GatewayPendingComponent extends GatewaysTableBaseComponent implements OnInit {

	@Input()
	public pendingGatewaysData: GatewayView[] | undefined = undefined;

	public pendingColumnSchema: GenericTable.ColumnSchema[] = [];
	public infoIcon: SdpIcon.Icon = {
		name: "info",
		type: "material",
		cssClass: "sdp-device-list-item-info sdp-gateway-pending-icon"
	};

	public ngOnInit() {
		this.pendingColumnSchema = this.getPendingGatewaySchema();
	}

	public getPendingGatewaySchema() {
		const pendingColumnSchema = this.getBaseGatewaySchema();
		pendingColumnSchema.unshift({
			minWidth: "5%",
			type: "customComponent",
			headerSchema: {
				type: "none",
			},
			bodySchema: {
				type: "customComponent",
				customComponent: PendingAcceptComponent,
				callback: (componentRef: ComponentRef<PendingAcceptComponent>, gateway: GatewayView) => {
					componentRef.instance.gateway = gateway;
				}
			}
		});

		const regDate: GenericTable.DateTimeColumnSchema = {
			minWidth: "20%",
			type: "dateTime",
			headerSchema: {
				type: "basic",
				sortable: true,
				headerText: "sdp.label.registrationDate"
			},
			bodySchema: {
				type: "dateTime",
				boundField: "registrationDate",
				displayCallback: createDateTimeDisplayCallback()
			}
		};

		const positionForDate = pendingColumnSchema.length - 1;
		pendingColumnSchema.splice(positionForDate, 0, regDate);

		return pendingColumnSchema;
	}
}
